<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="top-title-wrap">
          <div class="main-title">
            <span>{{ $t('Transaction Management') }}</span>
            <dspButtonGroup class="ml-1">

              <router-link class="button" :to="{ name: 'admin.transactions' }">{{ $t('Transactions') }}
              </router-link>
              <dspButton class="active">{{
                  $t('Net Terms')
                }}
              </dspButton>
            </dspButtonGroup>
          </div>
        </div>
        <box boxClass="alt">
          <tableTopActions class="reports-top-actions alt extended-top-actions-smallscreen">
            <!--                        <dspButton class="primary">+ User</dspButton>-->
            <dspButton class="button primary" @click="$refs.addAdvertiserModal.show()">
              {{ $t('+ Advertiser') }}
            </dspButton>
            <dspButton class="button " @click="openEditCreateModal(null)">
              {{ $t('+ Rule') }}
            </dspButton>

            <dspInput v-model="searchText"
                      @changed="searchText=$event"
                      :placeholder="$t('Search')"
                      class="search-input"></dspInput>

            <dropdown :dropValue="filter" :showSearch="false" :options="filters" @input="filter = $event"/>
          </tableTopActions>
          <b-table hover
                   ref="netTermsTable"
                   :fields="tableFields"
                   :items="netTermsProvider"
                   :sort-by.sync="sortBy"
                   :sort-desc.sync="sortDesc"
                   :show-empty="true"
                   :empty-text="$t('No data to display')">
            <template slot="HEAD_index">
              <dspActionCheckbox :isChecked="this.netTermSelected.length === this.items.length"
                                 :isDisabled="false"
                                 :actions="tableActions"
                                 :showActions="this.netTermSelected.length >= 1"
                                 @change="selectAllNetTerms($event)"
                                 @click="onAction($event)"/>
            </template>

            <template v-for="field in sortableFields">
              <template :slot="'HEAD_' + field.key">
                <sortableColumnHead :title="field.label" :key="field.key"/>
              </template>
            </template>

            <template slot="index" slot-scope="row">
              <dspActionCheckbox name="NetTerms[]"
                                 :value="row.item.id"
                                 :isChecked="netTermSelected.includes(row.item.id)"
                                 :isDisabled="false"
                                 :actions="['remove']"
                                 :showActions="false"
                                 @change="onNetTermselect(row, $event)"
                                 @click="onNetTermAction(row, $event)"></dspActionCheckbox>


            </template>
            <template v-slot:isActive="data">
              <dspSwitcher @change="changeStatus($event, data.item.id)" :enabled="!!data.item.isActive"></dspSwitcher>
            </template>
            <template v-slot:balance="data">
              $ {{ data.item.balance | finance }}
            </template>
            <template v-slot:totalSpend="data">
              $ {{ data.item.totalSpend | finance }}
            </template>
            <template v-slot:netPeriod="data">
              {{ data.item.netPeriod | integer }} <a @click="openEditNetPeriodModal(data.item)"
                                                     class="ml-2 cursor-pointer"> <img class="type-img"
                                                                                       src="../../images/icon-edit.svg"
                                                                                       alt=""> </a>
            </template>
            <template v-slot:dailyPayment="data">
              $ {{ data.item.dailyPayment | finance }} <a @click="openEditCreateModal(data.item)"
                                                          class="ml-2 cursor-pointer"> <img class="type-img"
                                                                                            src="../../images/icon-edit.svg"
                                                                                            alt=""> </a>
            </template>
            <template v-slot:spendForNetPeriod="data">
              $ {{ data.item.spendForNetPeriod | finance }}
            </template>
            <template v-slot:paid="data">
              $ {{ data.item.paid | finance }} <a @click="openAddPaymentModal(data.item)" class="ml-2 cursor-pointer">
              <img class="type-img" src="../../images/icon-edit.svg" alt=""> </a>
            </template>
            <template v-slot:period="data">
              <a href="#" @click="openEditCreateModal(data.item)">
                  <span v-if="data.item.fromDate && data.item.toDate">
            {{ data.item.fromDate }} -  {{ data.item.toDate }}

              </span> </a>
            </template>



          </b-table>
          <b-pagination v-if="pagination.totalPages > 1"
                        v-model="pagination.currentPage"
                        :total-rows="pagination.totalRows"
                        :per-page="pagination.perPage"
                        align="right"
                        aria-controls="data-table"
                        @change="changePage"></b-pagination>
        </box>
      </div>
    </div>

    <b-modal ref="addAdvertiserModal">
      <div slot="modal-header">
        <h5>{{ $t('Add Advertiser') }}</h5>
      </div>
      <div class="form-group full-width">
        <label class="group-title">{{ $t('Name') }}</label>
        <dspInput v-model="addAdvertiserData.name"
                  v-validate="'required|min:2'"
                  :errorsBag="errors"
                  name="nameNetTerms"
                  :placeholder="$t('Name')"></dspInput>
      </div>
      <div class="form-group full-width">
        <label class="group-title">{{ $t('User') }}</label>
        <dropdown v-model="addAdvertiserData.selectedUser"
                  :showSearch="true"
                  v-validate="'required'"
                  :options="users"
                  @search="getUsersListDebounce(null,$event)"
                  class="wide"
                  name="userIdNetTerms">

          <template v-slot:header="header">
                                              <span>{{
                                                  header.value ? header.value.text : $t('(Select User)')
                                                }}</span>
          </template>
          <template v-slot:item="item">
            <span>{{ item.option.text }}</span>
          </template>
        </dropdown>
      </div>
      <div class="form-group full-width">
        <label class="group-title">{{ $t('NET Terms') }}</label>
        <dspSelect v-model="addAdvertiserData.netPeriod"
                   :options="netPeriods"
                   v-validate="'required'"
                   :errorsBag="errors"
                   name="method"/>
      </div>
      <div slot="modal-footer">
        <dspButton v-on:click="$refs.addAdvertiserModal.hide()" class="plain">{{ $t('Cancel') }}
        </dspButton>
        <dspButton v-on:click="saveNetTerms" class="primary">{{ $t('Save') }}
        </dspButton>
      </div>
    </b-modal>

    <b-modal ref="addRuleModal" :title="editModal ? $t('Edit Rule') :  $t('Add Rule')" footer-class="alt">
      <div slot="modal-header">
        <h5>{{ editModal ? $t('Edit Rule') : $t('Add Rule') }}</h5>
      </div>
      <div class="form-group full-width">
        <label class="group-title">{{ $t('Net term id ') }}</label>
        <dropdown v-model="addRuleData.selectedNetTerm"
                  :showSearch="true"
                  :options="netTerms"
                  @search="getNetTermsListDebounce($event)"
                  class="wide">

          <template v-slot:header="header">
                                              <span>{{
                                                  header.value ? header.value.text : $t('(Select net term)')
                                                }}</span>
          </template>
          <template v-slot:item="item">
            <span>{{ item.option.text }}</span>
          </template>
        </dropdown>
      </div>
      <div class="form-group full-width">
        <label class="group-title">{{ $t('Daily Payment') }}</label>
        <dspInput :placeholder="$t('Enter Daily Amount')" v-model="dailyPayment" v-validate="{
                                          finance: true,

                                      }" :data-vv-as="$t('Daily Payment')" :errorsBag="errors"

                  name="dailyPayment"

        />
      </div>
      <div class="form-group full-width">
        <label class="group-title">{{ $t('Period') }}</label>
        <DateSelect :dateStart="addRuleData.period.from.format('YYYY-MM-DD')"
                    :dateEnd="addRuleData.period.to.format('YYYY-MM-DD')"
                    :errorsBag="errors"
                    :net-terms-presets="true"
                    :autoApply="false"
                    :value="rangeName"
                    @change="onPeriodChange($event)"
                    opens="left"
                    class="w-100"/>
      </div>
      <div slot="modal-footer">
        <dspButton v-if="editModal" v-on:click="updateNetTerms(true)" class="danger">{{ $t('Delete') }}
        </dspButton>
        <dspButton v-on:click="$refs.addRuleModal.hide()" class="plain">{{ $t('Cancel') }}
        </dspButton>
        <dspButton v-on:click="updateNetTerms" class="primary">{{ $t('Save') }}
        </dspButton>
      </div>
    </b-modal>

    <b-modal ref="addPaymentModal" dialog-class="small" footer-class="alt">
      <div slot="modal-header">
        <h5>{{ $t('Paid by Advertiser ' + updatePaymentUserId) }}</h5>
      </div>
      <div class="form-group full-width">
        <label class="group-title">{{ $t('Payment') }}</label>
        <dspInput :placeholder="$t('Enter payment')" v-model="paidModify" v-validate="{
                                          finance: true,

                                      }" :data-vv-as="$t('Payment')" :errorsBag="errors"
                  name="payment"

        />
      </div>

      <div slot="modal-footer">
        <dspButton v-on:click="$refs.addPaymentModal.hide()" class="plain">{{ $t('Cancel') }}
        </dspButton>
        <dspButton v-on:click="updatePayment" class="primary">{{ $t('Save') }}
        </dspButton>
      </div>
    </b-modal>
    <b-modal ref="editNetPeriodModal" dialog-class="small"  footer-class="alt">
      <div slot="modal-header">
        <h5>{{ $t('Edit NET Period ') }}</h5>
      </div>
      <div class="form-group full-width">
          <label class="group-title">{{ $t('Period') }}</label>
          <dspSelect v-model="netPeriod"
                     :options="netPeriods"
                     v-validate="'required'"
                     :errorsBag="errors"
                     name="method"/>

      </div>
      <div slot="modal-footer">
        <dspButton v-on:click="$refs.editNetPeriodModal.hide()" class="plain">{{ $t('Cancel') }}
        </dspButton>
        <dspButton v-on:click="updateNetPeriod" class="primary">{{ $t('Save') }}
        </dspButton>
      </div>
    </b-modal>
    <dspConfirmModal
      ref="deleteConfirmModal"
      :message="$t('Do You want to delete selected net terms?')"
      @confirm="onDeleteConfirm"
    />
  </div>
</template>

<script>
import { debounce } from 'debounce';
import sortableColumnHead from '@/components/shared/sortableColumnHead.vue';
import moment from 'moment';
import DateSelect from '@/components/DatePicker/DateSelect.vue';

import searchUsersMixin from '@/lib/searchUsers';
import { currencyFormatter, parse } from '@/lib/numberFormatters';
import dspActionCheckbox from '@/components/shared/dspActionCheckbox.vue';

export default {
  components: {
    dspActionCheckbox,
    sortableColumnHead,
    DateSelect
  },
  mixins: [searchUsersMixin],

  name: 'admin-transaction',
  data: function () {
    return {
      editModal: false, //addAdvertiserModal
      addAdvertiserData: {
        name: '',
        selectedUser: null,

        netPeriod: 30,
      },
      netPeriod: 0,
      users: [],
      netPeriods: [
        {
          value: 5,
          text: this.$t('NET5')
        },
        {
          value: 154,
          text: this.$t('NET14')
        },
        {
        value: 30,
        text: this.$t('NET30')
      },
        {
          value: 45,
          text: this.$t('NET45')
        },{
        value: 60,
        text: this.$t('NET60')
      }, {
        value: 90,
        text: this.$t('NET90')
      },],

      //addRuleModal
      addRuleData: {
        selectedNetTerm: null,
        dailyPayment: null,
        netPeriod: null,
        period: {
          from: moment(),
          to: moment().add(29, 'days')
        },
      },

      netTerms: [],

      searchText: '',
      sortDesc: true,
      sortBy: 'id',

      pagination: {
        currentPage: 1,
        perPage: 10,
        totalRows: 100,
        totalPages: 1,
      },

      tableFields: [{
        key: 'index',
        label: this.$t('Index'),
        class: 'th-sel',
        sortable: false
      }, {
        key: 'id',
        label: this.$t('Id'),
        sortable: true, // class: 'admin-user-id'
      }, {
        key: 'isActive',
        label: this.$t('Status'),
        sortable: true, // class: 'admin-user-id'
      }, {
        key: 'userId',
        label: this.$t('User id'),
        sortable: true,
      }, {
        key: 'name',
        label: this.$t('Name'),
        sortable: true,
      }, {
        key: 'balance',
        label: this.$t('Balance'),
        sortable: true,
      }, {
        key: 'netPeriod',
        label: this.$t('Net Period'),
        sortable: true,
      }, {
        key: 'dailyPayment',
        label: this.$t('Rule'),
        sortable: true,
      }, {
        key: 'period',
        label: this.$t('Period'),
        sortable: true,
      }, {
        key: 'totalSpend',
        label: this.$t('totalSpend'),
        sortable: false,
      }, {
        key: 'spendForNetPeriod',
        label: this.$t('Spend for Net Period'),
        sortable: false,
      }, {
        key: 'paid',
        label: this.$t('Paid'),
        sortable: true,
      },],
      items: [],
      updatePaymentUserId: null,
      updatePaymentNetTermsId: null,
      paid: 0,
      updatePaymentSpendForNetPeriod: 0,
      filter: this.$t('User ID'),
      filters: [this.$t('User ID'), this.$t('Name'), this.$t('ID')], // eslint-disable-next-line
      netTermSelected: [],
      tableActions: ['remove'],
    };
  },

  watch: {
    filter: function () {
      this.pagination.currentPage = 1;
      this.$refs.netTermsTable.refresh();
    },
    searchText () {
      this.pagination.currentPage = 1;
      this.$refs.netTermsTable.refresh();
    }, // netTermSelected: function () {
    //   if (this.netTermSelected.length === 0) {
    //     this.tableActions = [];
    //     return;
    //   }
    //   if (this.netTermSelected.length > 15) {
    //     this.tableActions = ['remove', 'duplicate'];
    //     return;
    //   }
    //   // if (this.netTermSelected.length <= 5) {
    //   this.tableActions = ['edit', 'remove', 'duplicate'];
    //   // return;
    //   // }
    // }
  },

  created () {
    if (!this.$auth.checkFinanceAdmin()) {
      this.$router.push({ name: 'admin.dashboard' });
    }
  },

  mounted () {
    // this.$refs.addAdvertiserModal.show();
  },
  computed: {
    searchFilter: function () {
      switch (this.filter) {
        case this.$t('Name'):
          return 'name:like';
        case this.$t('ID'):
          return 'id:like';
        case this.$t('User ID'):
          return 'userId:like';
        default:
          return 'name:like';
      }
    },

    searchField: function () {
      switch (this.filter) {
        case this.$t('Name'):
          return 'name';
        case this.$t('ID'):
          return 'id';
        case this.$t('User ID'):
          return 'userId';
        default:
          return 'name';
      }
    },
    sortableFields () {
      return this.tableFields.filter(item => item.sortable).map(item => ({
        key: item.key,
        label: item.label
      }));
    },
    rangeName () {
      return this.addRuleData.period.from.format('YYYY-MM-DD') + ' - ' + this.addRuleData.period.to.format('YYYY-MM-DD');
    },
    dailyPayment: {
      get: function () {
        return currencyFormatter(this.addRuleData.dailyPayment);
      },
      set (val) {
        this.addRuleData.dailyPayment = parse(val);

        this.$nextTick(() => {
          this.$validator.validate('dailyPayment', val);
        });
      }
    },
    paidModify: {
      get: function () {
        return currencyFormatter(this.paid);
      },
      set (val) {
        this.paid = parse(val);

        this.$nextTick(() => {
          this.$validator.validate('payment', val);
        });
      }
    },
  },
  methods: {
    onNetTermselect (row, isSelected) {

      const id = row.item.id;
      if (isSelected) {
        this.netTermSelected.push(id);
        row.item._rowVariant = 'selected';
      } else {
        this.netTermSelected = this.netTermSelected.filter(i => {
          return i !== id;
        });
        row.item._rowVariant = '';
      }
    },
    onDeleteConfirm () {
      this.$refs.deleteConfirmModal.hide();

      let isPlular = this.netTermSelected.length === 1 ? this.$t('Net term...') : this.$t('Net terms...');
      this.$notify.info('Removing ' + isPlular);
      this.netTermSelected.map((id, i, arr) => {
        this.axios.delete('/admin/net-terms/' + id).then(() => {
          if ((i + 1) === arr.length) {
            this.$notify.info(this.$t('Removed successfully!'));
            this.pagination.currentPage = 1;
            this.$refs.netTermsTable.refresh();
          }
        }).catch(() => {
          this.$notify.error(this.$t('Fail to remove net term ID# ') + id);
        });
      });
    },
    onAction (action) {
      switch (action) {
        case 'remove':
          this.$refs.deleteConfirmModal.show();
          break;
      }
    },
    selectAllNetTerms (isSelected) {
      if (isSelected) {
        this.netTermSelected = this.items.map(i => i.id);
      } else {
        this.netTermSelected = [];
      }
    },
    openEditCreateModal (item) {
      if (item === null) {
        this.editModal = false;
        this.addRuleData.period.from = moment();
        this.addRuleData.period.to = moment().add(29, 'days');
        this.addRuleData.dailyPayment = null;
        this.addRuleData.selectedNetTerm = null;
        this.addRuleData.netPeriod = null;
      } else {

        this.editModal = true;
        if (item.fromDate !== null && item.toDate !== null) {
          this.addRuleData.period.from = moment(item.fromDate);
          this.addRuleData.period.to = moment(item.toDate);
        } else {
          this.addRuleData.period.from = moment();
          this.addRuleData.period.to = moment().add(29, 'days');

        }
        this.addRuleData.netPeriod = item.netPeriod;
        this.addRuleData.dailyPayment = item.dailyPayment;
        this.addRuleData.selectedNetTerm = {
          value: item.id,
          text: item.id + ' | ' + item.name,
        };
      }
      this.$refs.addRuleModal.show();
    },
    onPeriodChange (event) {
      this.addRuleData.period.from = moment(event.dateStart);
      this.addRuleData.period.to = moment(event.dateEnd);
    },
    async saveNetTerms () {
      let checkFields = false;
      await this.$validator.validate('nameNetTerms').then(valid => {
        checkFields = valid;
        this.$validator.validate('userIdNetTerms').then(valid => {
          checkFields === false ? checkFields = false : checkFields = valid;
        });
      });
      if (checkFields) {
        let data = {
          name: this.addAdvertiserData.name,
          netPeriod: this.addAdvertiserData.netPeriod,
          userId: this.addAdvertiserData.selectedUser.value,
        };
        this.$axios.post('/admin/net-terms', data).then(res => {
          if (res.status === 200) {
            this.$notify.info(this.$t('Saved.'));
          }
        }).catch(error => {
          this.$backendErrors(error, this.$t('Error save: '), this.$validator);
        }).finally(() => {
          this.$refs.addAdvertiserModal.hide();
          this.$refs.netTermsTable.refresh();
        });

      }
    },
    getUsersListDebounce: debounce(function (type = null, search, loading) {
      this.getUsersList(search, loading, type);
    }, 500),
    getNetTermsListDebounce: debounce(function (search, loading) {
      this.getNetTermsList(search, loading);
    }, 500),
    getNetTermsList (search, loading) {
      let searchUrl = '';
      if (search) {
        searchUrl = '&searchFields=id:like;name:like;userId:like;&search=' + search;
      }
      this.$axios.get('/admin/net-terms?orderBy=id&sortedBy=desc&perPage=10' + searchUrl)
          .then(response => {
            let fieldValue = 'value';
            let fieldText = 'text';

            this.netTerms = response.data.data.map(item => ({
              [fieldValue]: item.id,
              [fieldText]: `ID: ${item.id} | ${item.name} | UserdId:${item.userId} `
            }));

            if (loading) {
              loading(false);
            }
          })
          .catch(() => {
            this.users = [];

            if (loading) {
              loading(false);
            }
          });
    },
    changePage (pageNo) {
      this.pagination.currentPage = pageNo;
      this.$refs.netTermsTable.refresh();
    },

    refreshTableDebounced: debounce(function () {
      this.$refs.netTermsTable.refresh();
    }, 1000),

    netTermsProvider (ctx) {

      let sortBy = ctx.sortBy;
      const params = new URLSearchParams();
      params.append('page', this.pagination.currentPage);

      const sortReplaser = {
        balance: 'users|balance',
        period: 'fromDate',

      };
      if (sortReplaser[sortBy]) {
        sortBy = sortReplaser[sortBy];
      }

      params.append('searchJoin', 'and');
      params.append('search', this.searchText);
      params.append('searchFields', this.searchFilter);

      params.append('orderBy', sortBy);
      params.append('sortedBy', ctx.sortDesc ? 'desc' : 'asc');
      // params.append('with', 'user');

      return this.axios.get('/admin/net-terms', { params: params })
          .then(response => {
            this.pagination.currentPage = response.data.meta.pagination.current_page;
            this.pagination.perPage = response.data.meta.pagination.per_page;
            this.pagination.totalRows = response.data.meta.pagination.total;
            this.pagination.totalPages = response.data.meta.pagination.total_pages;
            const items = response.data.data.map(item => ({
              id: item.id,
              isActive: item.isActive,
              userId: item.userId,
              name: item.name,
              balance: item.balance,
              netPeriod: item.netPeriod,
              dailyPayment: item.dailyPayment,
              fromDate: item.fromDate,
              toDate: item.toDate,
              paid: item.paid,
              totalSpend: item.totalSpend,
              spendForNetPeriod: item.spendForNetPeriod,
            }));
            this.items = items;
            this.netTermSelected = [];
            return items || [];
          })
          .catch(error => {
            this.pagination.currentPage = 0;
            this.pagination.perPage = 0;
            this.pagination.totalRows = 0;
            this.items = [];

            this.$backendErrors(error, this.$t('Error'));

            return [];
          });
    },
    changeStatus (event, itemId) {
      this.$axios.patch('/admin/net-terms/' + itemId, { isActive: event }).then(res => {
        if (res.status === 200) {
          this.$notify.info(this.$t('Changed status.'));
        }
      }).catch(error => {
        this.$backendErrors(error, this.$t('Error save: '), this.$validator);
      }).finally(() => {
        this.$refs.netTermsTable.refresh();
      });
    },
    updateNetTerms (deleted = false) {
      if (this.addRuleData.selectedNetTerm === null) {
        this.$notify.error(this.$t('Need select net term id.'));
        return;
      }

      let data = {
        dailyPayment: this.addRuleData.dailyPayment,
        fromDate: this.addRuleData.period.from,
        toDate: this.addRuleData.period.to,
        netPeriod: this.addRuleData.netPeriod,
      };
      if (deleted) {
        data = {
          dailyPayment: 0,
          fromDate: null,
          toDate: null,
          netPeriod: 0,
        };

      }
      this.$axios.patch('/admin/net-terms/' + this.addRuleData.selectedNetTerm.value, data).then(res => {
        if (res.status === 200) {
          this.$notify.info(this.$t('Changed.'));
        }
      }).catch(error => {
        this.$backendErrors(error, this.$t('Error save: '), this.$validator);
      }).finally(() => {
        this.$refs.addRuleModal.hide();
        this.$refs.netTermsTable.refresh();
      });
    },
    openAddPaymentModal (item) {
      this.updatePaymentUserId = item.userId;
      this.updatePaymentNetTermsId = item.id;
      this.updatePaymentSpendForNetPeriod = item.spendForNetPeriod;
      this.paid = item.paid;
      this.$refs.addPaymentModal.show();

    },
    updatePayment () {
      this.$axios.patch('/admin/net-terms/' + this.updatePaymentNetTermsId, { paid: this.paid }).then(res => {
        if (res.status === 200) {
          this.$notify.info(this.$t('Changed payment.'));
          if (this.updatePaymentSpendForNetPeriod > this.paid) {
            this.changeStatus(false, this.updatePaymentNetTermsId);
          }
        }

      }).catch(error => {
        this.$backendErrors(error, this.$t('Error save: '), this.$validator);
      }).finally(() => {
        this.$refs.addPaymentModal.hide();
        this.$refs.netTermsTable.refresh();
      });
    },
    openEditNetPeriodModal (item) {
      this.updatePaymentUserId = item.userId;
      this.updatePaymentNetTermsId = item.id;
      this.netPeriod = item.netPeriod;
      this.$refs.editNetPeriodModal.show();
    },
    updateNetPeriod () {
      this.$axios.patch('/admin/net-terms/' + this.updatePaymentNetTermsId, { netPeriod: this.netPeriod }).then(res => {
        if (res.status === 200) {
          this.$notify.info(this.$t('Changed net period.'));
        }
      }).catch(error => {
        this.$backendErrors(error, this.$t('Error save: '), this.$validator);
      }).finally(() => {
        this.$refs.editNetPeriodModal.hide();

        this.$refs.netTermsTable.refresh();
      });
    }
  }

};
</script>

<style lang="scss" scoped>
.automated-dates {
  .mdrp-root {
    width: 100%;
  }
}

.approve, .decline {
  display: inline-block;
  margin-left: 10px;
  cursor: pointer;
}

.export-button-right {
  position: absolute;
  right: 55px;
}

table.table.b-table > thead > tr > th.pointer-event-none {
  pointer-events: none;
}

.cursor-pointer {
  cursor: pointer;
}

.dropdown ::v-deep {
  .dropdown-trigger {
    display: flex;
    align-items: center;
  }
}

::v-deep .mdrp-root {
  width: 100%;
}

</style>
